/* eslint-disable complexity */
/* eslint max-lines: ["error", 1500] */

import { TF_DATA_POST_KEYS } from '../utils/constants';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import Utils from '../../../../common/utils';
const MAGENTA_ID = 'magenta';
const FIXED_ID = 'fixed';
const POSTPAID_ID = 'postpaid';
const PREPAID_ID = 'prepaid';
const UNLIMITED_DATA_ID = 'unlimitedData';
const ORGANIZATION_TYPE_ID = 'organization';
const LOADING_STATES = {
	INIT: 'INIT',
	LOADING: 'LOADING',
	NOT_AUTHORIZED: 'NOT_AUTHORIZED',
	SUCCESS: 'SUCCESS',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR',
	FIELDS_NOT_AVAILABLE: 'FIELDS_NOT_AVAILABLE'
};
export default [
	'$scope',
	'dynaFormFactory',
	'storgeFactory',
	'$window',
	'queryParamDictionary',
	'$timeout',
	'$sce',
	'$cookies',
	function ($scope, dynaFormFactory, storgeFactory, $window, queryParamDictionary, $timeout, $sce, $cookies) {
		var CONSTANTS = {
			AVAS_ADDRESS_SELECTOR_CLASS: '.avas_main',
			AVAS_ADDRESS_VALIDATION_MESSAGE_CLASS: 'address-bar__input-error-msg--hidden',
			LABEL_ERROR_CLASS: 'ng-invalid',
			AVAS_INPUT_ERROR_CLASS: 'address-bar__input-error-msg--visible',
			AVAS_ERROR_MESSAGE_SELECT: '.address-bar__input-error-msg*'
		};
		$scope.loadingState = LOADING_STATES.INIT;
		var lastErrorsFromServer = [];
		$scope.currentStep = '1';
		$scope.addressRadioState = null;
		$scope.setDefaultInputValuesNotCalled = true;
		$scope.avasAddressSelectorIsExist = false;
		$scope.dataForThankYouPage = {};
		angular.element(document).ready(function () {
			$scope.pageLoadTime = Date.now() - $window.timerStart;
		});
		$scope.queryparams = {};
		$scope.mtUserFormModel = {
			userDetails: null,
			selectedSubscriber: '',
			subscriberNameRestKey: '',
			subscriberMtIdRestKey: '',
			selectIsDisabled: true
		};
		$scope.optinModel = {
			allDmAccepted: false,
			selectAllDmCheckboxIsDisabled: true,
			conditionalTextIsOpened: false,
			dmCheckboxesIsOpened: false,
			contactedSubscriberName: ''
		};
		/**
		 * @type {Array}
		 * ide pusholjuk azokat az elemeket amiket nem kell törölni submit esetén
		 * (ha nem talál visible inputot a data objektum valamely kulcsához, akkor az nem kerül postolásra)
		 */
		$scope.exceptArrayForDeleteWhenSubmit = [];

		$scope.emptyCurrentStep = function () {
			if (!$scope.data) {
				$scope.data = {};
			}
			$scope.data[$scope.currentStep] = {};
		};

		function getFormId() {
			return $('.dn-form').attr('id');
		}

		function getQueryParams(qs) {
			qs = qs.split('+').join(' ');

			var params = {},
				tokens,
				re = /[?&]?([^=]+)=([^&]*)/g;

			while ((tokens = re.exec(qs))) {
				params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
			}

			return params;
		}

		function setQueryParams() {
			var queryParams = getQueryParams($window.location.search);
			for (var key in queryParamDictionary) {
				$scope.queryparams[queryParamDictionary[key]] = {
					selectedIndex: queryParams[key]
				};
			}
		}

		function isInteger(value) {
			return Math.floor(value) == value;
		}

		function designSelectHasPlaceholderAttribute(inputId) {
			var hasPlaceholder = true;
			var element = angular.element('#' + inputId)[0];
			if (!element) {
				return !hasPlaceholder;
			}

			var attributeObject = element.attributes;
			var PLACEHOLDER_ATTRIBUTE = 'data-placeholder-check';

			for (var key in attributeObject) {
				if (attributeObject[key].name == PLACEHOLDER_ATTRIBUTE) {
					return hasPlaceholder;
				}
			}
			return !hasPlaceholder;
		}

		$scope.getSelectedDesigSelectOption = function (inputId, options) {
			var hasPlaceholder = designSelectHasPlaceholderAttribute(inputId);
			var optionLength = hasPlaceholder ? options.length - 1 : options.length;
			var selectedIndex = $scope.queryparams[inputId].selectedIndex;

			if (!isInteger(selectedIndex) || optionLength < selectedIndex || selectedIndex <= 0) {
				selectedIndex = hasPlaceholder ? 0 : null;
			} else if (hasPlaceholder) {
				selectedIndex = parseInt(selectedIndex);
			} else {
				selectedIndex--;
			}

			return selectedIndex;
		};

		setQueryParams();

		// query param example:
		// ?title=h%C3%A9llo&id=123456789&ti=Mr&fi=John&la=Doe&email=sdfsdfds@asdsd.com&tel=1234567
		$scope.setDefaultInputValues = function () {
			var queryParams = getQueryParams($window.location.search);

			for (var key in queryParams) {
				var defaultValue = queryParams[key];
				var inputId = queryParamDictionary[key];

				if (inputId) {
					if ($scope.DynaFormMain) {
						// Closure is necessary because we are in a loop, and timeout is async.
						(function (id, value) {
							// Timeout is needed because the input element is placed into DOM by ng-if, and we should wait for it
							$timeout(function () {
								if (angular.element('#' + id)[0] && angular.element('#' + id).find('[type=checkbox]').length) {
									var checkedCheckbox = value.split(',');
									var checkboxElements = angular.element('#' + id).find('[type=checkbox]');
									for (var i = 0; i < checkedCheckbox.length; i++) {
										checkboxElements[checkedCheckbox[i] - 1].checked = true;
									}
								} else if (angular.element('#' + id)[0] && angular.element('#' + id)[0].type == 'checkbox') {
									angular.element('#' + id)[0].checked = true;
								} else if (angular.element('#' + id)[0] && angular.element('#' + id).find('[type=radio]').length) {
									angular
										.element('#' + id)
										.find('[type=radio]')
										[value - 1].click();
									angular.element('#' + id).removeAttr('id');
								} else if (angular.element('#' + id)[0] && angular.element('#' + id)[0].tagName.toLowerCase() == 'input') {
									if (id.indexOf('_') > -1) {
										var objectKey = id.split('_');
										if (!$scope.data[$scope.currentStep][objectKey[0]]) {
											$scope.data[$scope.currentStep][objectKey[0]] = {};
										}
										$scope.data[$scope.currentStep][objectKey[0]][angular.element('#' + id)[0].name] = value;
									} else {
										$scope.data[$scope.currentStep][angular.element('#' + id)[0].name] = value;
									}
								} else if (angular.element('#' + id)[0] && !angular.element('#' + id)[0].tagName.toLowerCase() == 'select') {
									angular.element('#' + id).html(value);
								}
							});
						})(inputId, defaultValue);
					}
				}
			}
			setTimeout(function () {
				if ($scope.setDefaultInputValuesNotCalled) {
					$scope.setDefaultInputValuesNotCalled = false;
				}
			});
		};

		function resetLastErrors() {
			for (var i = 0; i < lastErrorsFromServer.length; i++) {
				var error = lastErrorsFromServer[i];

				for (var j = 0; j < error.errors.length; j++) {
					$scope.DynaFormMain[error.field].$setValidity(error.errors[j], true);
				}
			}
		}

		function getPersonalizedModuleDWHValues(identifier) {
			// Megkeresi az azonosító alapján a perszonalizált modult
			var personalizedElements = document.querySelectorAll('[data-dyna-personalized-module-input="' + identifier + '"]');

			// Hiba üzenet, ha nincs megfelelő elem beszerkesztve
			if (personalizedElements.length === 0) {
				return '"data-dyna-personalized-module-input" attribute not found on any element with "' + identifier + '" value';
			}

			// A visszaadni kívánt érték összeállítása
			var personalizedHiddenInputValue = '';
			// Összegyüjti az értékeket a hidden input mező számára
			for (var i = 0; i < personalizedElements.length; i++) {
				personalizedHiddenInputValue += personalizedElements[i].getAttribute('data-personalized-id') + ', ';
			}

			return personalizedHiddenInputValue.slice(0, -2); // az utolsó ', '-t levágja
		}

		function fillDWHHiddenInputs() {
			// Feltölti a DWH-hez tartozó hidden input mezőket a szükséges értékekkel
			var m09pHiddenInput = document.querySelectorAll('[name="' + $window.dynaFormM09p + '"]')[0];
			if ($window.dynaFormM09p && m09pHiddenInput) {
				if (m09pHiddenInput.attributes.name) {
					// A hidden input mező name attributumának értéke lesz a form data objektumban kulcs
					$scope.keyForFormDataM09P = m09pHiddenInput.attributes.name.value;
					$scope.data[$scope.currentStep][$scope.keyForFormDataM09P] = getPersonalizedModuleDWHValues($window.dynaFormM09p);
				}
			}

			var m11pHiddenInput = document.querySelectorAll('[name="' + $window.dynaFormM11p + '"]')[0];
			if ($window.dynaFormM11p && m11pHiddenInput) {
				if (m11pHiddenInput.attributes.name) {
					// A hidden input mező name attributumának értéke lesz a form data objektumban kulcs
					$scope.keyForFormDataM11P = m11pHiddenInput.attributes.name.value;
					$scope.data[$scope.currentStep][$scope.keyForFormDataM11P] = getPersonalizedModuleDWHValues($window.dynaFormM11p);
				}
			}

			var m13pHiddenInput = document.querySelectorAll('[name="' + $window.dynaFormM13p + '"]')[0];
			if ($window.dynaFormM13p && m13pHiddenInput) {
				if (m13pHiddenInput.attributes.name) {
					// A hidden input mező name attributumának értéke lesz a form data objektumban kulcs
					$scope.keyForFormDataM13P = m13pHiddenInput.attributes.name.value;
					$scope.data[$scope.currentStep][$scope.keyForFormDataM13P] = getPersonalizedModuleDWHValues($window.dynaFormM13p);
				}
			}
			// Az angularon kivüli perszonalizált modulokat elrejti nativ js-el
			var personalizedModules = document.getElementsByClassName('js-personalized');
			for (var i = 0; i < personalizedModules.length; i++) {
				personalizedModules[i].style.display = 'none';
			}
		}

		/**
		 * Törli az összes kulcsot (az alobjektumokban is), amely null,
		 * valamint a boolean változókat stringé konvertálja, mert a backend nem tudja feldolgozni a boolean -t
		 * @param object
		 */
		function deleteAllLevelObjectPropertiesIfIsNull(object) {
			for (var key in object) {
				if (object[key] == null) {
					delete object[key];
				} else if (typeof object[key] == 'object') {
					deleteAllLevelObjectPropertiesIfIsNull(object[key]);
				} else if (typeof object[key] == 'boolean') {
					object[key] = object[key].toString();
				}
			}
			return object;
		}

		function showAvasAddressErrorMessage() {
			var validationMessageElement = angular.element('.' + CONSTANTS.AVAS_ADDRESS_VALIDATION_MESSAGE_CLASS);
			validationMessageElement.show();
			validationMessageElement.addClass(CONSTANTS.AVAS_INPUT_ERROR_CLASS);
			validationMessageElement.removeClass(CONSTANTS.AVAS_ADDRESS_VALIDATION_MESSAGE_CLASS);
		}

		function removeClassAvasErrorLabel() {
			var validationMessageElement = angular.element(CONSTANTS.AVAS_ERROR_MESSAGE_SELECT);
			validationMessageElement.removeClass(CONSTANTS.LABEL_ERROR_CLASS);
		}

		function addClassAvasErrorLabel() {
			if ($scope.avasAddressSelectorIsExist) {
				var validationMessageElement = angular.element(CONSTANTS.AVAS_ERROR_MESSAGE_SELECT);
				validationMessageElement.addClass(CONSTANTS.LABEL_ERROR_CLASS); // azért kell, hogy scroll-to-first-error oda scrollozon
			}
		}

		function avasAddressIsValid() {
			var isValid = true;
			if (!$scope.avasAddressSelectorIsExist) {
				// ne legyen invalid a form ha nincs avas címbekérő
				return isValid;
			} else if (window.AvasAddress.getCurrentAddress()) {
				removeClassAvasErrorLabel();
				return isValid;
			}
			addClassAvasErrorLabel();
			showAvasAddressErrorMessage();
			return !isValid;
		}

		function renameChildKeysAndAddRootObject(avasAddress, parentObjectKey, childObjectKeys) {
			for (var i = 0; i < childObjectKeys.length; i++) {
				avasAddress[parentObjectKey + '_' + childObjectKeys[i]] = avasAddress[parentObjectKey][childObjectKeys[i]];
			}
			return avasAddress;
		}

		function replaceAvasModelToOneObjectLevel(avasAddress) {
			for (var key in avasAddress) {
				if (typeof avasAddress[key] == 'object') {
					var childObjectKeys = Object.keys(avasAddress[key]);
					avasAddress = renameChildKeysAndAddRootObject(avasAddress, key, childObjectKeys);
					delete avasAddress[key];
				}
			}
			return avasAddress;
		}
		function appendPPC() {
			const ppc = $cookies.get(Utils.PORTAL_PERSISTENT_COOKIE_NAME);
			$scope.sendData[$scope.currentStep].PPC = ppc;
		}
		function appendAvasModelIfExist() {
			if ($scope.avasAddressSelectorIsExist && window.AvasAddress.getCurrentAddress()) {
				var avasAddress = window.AvasAddress.getCurrentAddress();
				avasAddress = deleteAllLevelObjectPropertiesIfIsNull(avasAddress);
				avasAddress = replaceAvasModelToOneObjectLevel(avasAddress);
				$scope.sendData[$scope.currentStep].avas = avasAddress;
			}
		}

		function checkAvasAddressSelectorIsExist() {
			if (angular.element(CONSTANTS.AVAS_ADDRESS_SELECTOR_CLASS).length) {
				$scope.avasAddressSelectorIsExist = true;
			}
		}

		/**
		 * Ellenőrzi a form data objektumjait is, hogy üres stringet és false értéket, valamint üres objektumot ne postoljon be
		 * @param data: objektum típus, ami a form adatait tartalmazza
		 * @param dataPropertyKey
		 */
		function checkMultiSelectsProperties(data, dataPropertyKey) {
			if (typeof data[dataPropertyKey] == 'object') {
				for (var key in data[dataPropertyKey]) {
					if (!data[dataPropertyKey][key]) {
						delete data[dataPropertyKey][key];
					}
				}
			}
			if (angular.equals(data[dataPropertyKey], {})) {
				delete data[dataPropertyKey];
			}
		}

		$scope.sendForm = function (data, formId, sessionId) {
			resetLastErrors();
			lastErrorsFromServer = [];
			$scope.refreshDS();
			if (avasAddressIsValid() && $scope.DynaFormMain.$valid) {
				fillDWHHiddenInputs();
				$scope.sendData = angular.copy(data);
				$scope.resetHiddenInputsValueWhenSubmit();
				appendPPC();
				appendAvasModelIfExist();
				$scope.postDynaForm($scope.sendData, formId, sessionId);
			}
		};

		var childNodeScrapper = function (tagName, inputs, dataToConcat) {
			for (var i = 0; i < inputs[0].childNodes.length; i++) {
				if (inputs[0].tagName === tagName) {
					if (inputs[0].childNodes.checked) {
						dataToConcat += inputs[0].childNodes[i].innerText + ', ';
					} else {
						childNodeScrapper(inputs[0].childNodes, 'INPUT', inputs, dataToConcat);
					}
				}
			}
		};

		var singleInputValueGetter = function (thankYouPageIds, inputs, dataToConcat) {
			if (inputs[0]) {
				if (inputs[0].tagName === 'DIV') {
					childNodeScrapper('LABEL', inputs, dataToConcat);
					var lastCommaIndex = dataToConcat.length - 2;
					dataToConcat = dataToConcat.substring(0, lastCommaIndex);
					$scope.dataForThankYouPage[thankYouPageIds] = dataToConcat;
				} else if (inputs[0].type == 'checkbox') {
					// Checkbox esetén visszaadja a checked/nem checked állapotot
					dataToConcat = inputs[0].checked ? 'Igen' : 'Nem';
					$scope.dataForThankYouPage[thankYouPageIds] = dataToConcat;
				} else {
					$scope.dataForThankYouPage[thankYouPageIds] = $(inputs).val();
				}
			}
		};

		var groupedInputsValueGetter = function (thankYouPageIds, inputs, dataToConcat) {
			// Ha a csoportnak 1-nél több tagja van, akkor végig iterál a csoporton
			for (var j = 0; j < inputs.length; j++) {
				// Ha a csoport nem 'DIV', de radio type checkbox és checked, kiveszi a labeljét
				if (inputs[j].type === 'radio' && inputs[j].checked) {
					dataToConcat += inputs[j].parentNode.innerText + ' ';
				} else if (inputs[j].tagName === 'DIV') {
					// Ha a csoport 'DIV', azaz radio button group, akkor angular scope-ból kell kiszednie az értékét
					var radioDivChilds = inputs[j].childNodes;
					for (var k = 0; k < radioDivChilds.length; k++) {
						if (radioDivChilds[k].classList) {
							if (radioDivChilds[k].classList.contains('radio--active')) {
								dataToConcat = radioDivChilds[k].innerText + ' ';
							}
						}
					}
				} else {
					// Ha nem div tag a csoport, akkor végig iterál rajta, és összefűzi az értékeit
					if ($(inputs[j]).attr('type') !== 'radio') {
						// A telefon körzetszám értékhez a design szelekt hozzáfüzi mindig az adat tipust is, ezt törölni kell
						if ($(inputs[j]).val().substring(0, 6) === 'number' || $(inputs[j]).val().substring(0, 6) === 'string') {
							dataToConcat += $(inputs[j]).val().substring(7) + ' ';
						} else {
							dataToConcat += $(inputs[j]).val() + ' ';
						}
					}
				}
			}
			var lastSpaceIndex = dataToConcat.length - 1;
			dataToConcat = dataToConcat.substring(0, lastSpaceIndex);

			// dataToContact karakter hossza space nélkül (üres-e a változó teszt)
			var dataToConcatLetterNumExceptSpace = dataToConcat.replace(/\s/g, '').length;

			// Az összegyüjtött értékeket hozzá adja a thank you page számára létrejövő objektumhoz a megfelelő kulcs alatt
			if (dataToConcatLetterNumExceptSpace) {
				$scope.dataForThankYouPage[thankYouPageIds] = '';
				$scope.dataForThankYouPage[thankYouPageIds] = dataToConcat;
			}
		};

		var deleteUndefinedOrEmptyValuedProperties = function (dataForThankYouPage) {
			for (var key in dataForThankYouPage) {
				if (typeof dataForThankYouPage[key] == 'undefined' || dataForThankYouPage[key] === '') {
					delete dataForThankYouPage[key];
				}
			}
		};

		$scope.getDataForThankYouPage = function () {
			var thankYouPageIds = window.thankYouPageIds;
			if (!thankYouPageIds || !thankYouPageIds[0]) {
				return;
			}

			// Végig iterál az elemeken, amiből szükség van az value-ra a thank you page számára
			for (var i = 0; i < thankYouPageIds.length; i++) {
				// Összegyüjti az adott elem csoportokat, amik egy groupba tartoznak (pl.: contact_firstName, contact_lastName)
				var inputs = $('[name*=' + thankYouPageIds[i] + ']');
				var dataToConcat = '';
				// Ha a csoportnak 1 tagja van, begyüjti az értékét
				if (inputs.length < 2) {
					singleInputValueGetter(thankYouPageIds[i], inputs, dataToConcat);
				} else {
					groupedInputsValueGetter(thankYouPageIds[i], inputs, dataToConcat);
				}
				deleteUndefinedOrEmptyValuedProperties($scope.dataForThankYouPage);
			}
		};

		$scope.postDynaForm = function (data, formId, sessionId) {
			$scope.getDataForThankYouPage();
			$scope.backgroundOperationInProgress = true;
			dynaFormFactory.sendForm(data, formId, sessionId, function (response) {
				var responseData = response.data;

				if (responseData) {
					if (responseData.status == 'OK') {
						storgeFactory.saveFormData($scope.currentStep, data);
						storgeFactory.saveCompletedFormExpiration(formId);
						$scope.navigateOrShowThankYouMessage();
					} else {
						$scope.backgroundOperationInProgress = false;
						$scope.showServerErrorMessage();
					}
				} else {
					$scope.backgroundOperationInProgress = false;
					$scope.showServerErrorMessage();
				}
			});
		};

		$scope.navigateOrShowThankYouMessage = function () {
			if (window.thankYouPageUrl) {
				window.location.href = window.thankYouPageUrl;
			} else {
				$scope.responseSuccess = true;
				dynaFormFactory.scrollToThankYouContent();
			}
		};

		$scope.showServerErrorMessage = function () {
			$scope.showErrorMessage = !$scope.showErrorMessage;
		};

		$scope.resetHiddenInputsValueWhenSubmit = function () {
			for (var key in $scope.sendData[$scope.currentStep]) {
				if ($scope.exceptArrayForDeleteWhenSubmit.indexOf(key) >= 0) {
					return;
				}

				if (angular.element(document).find('[name*="' + key + '"]').length == 0 && key != 'myCaptchaDiv' && !Object.values(TF_DATA_POST_KEYS).includes(key)) {
					if ($scope.sendData[$scope.currentStep][key] != undefined && key != $scope.captchaElementId) {
						delete $scope.sendData[$scope.currentStep][key];
					}
				}

				if ($scope.sendData[$scope.currentStep][key] == undefined || $scope.sendData[$scope.currentStep][key] == '') {
					delete $scope.sendData[$scope.currentStep][key];
				}

				checkMultiSelectsProperties($scope.sendData[$scope.currentStep], key);
			}
		};

		$scope.showValidationMessage = function () {
			if (!$scope.addressRadioState) {
				return false;
			}
			return true;
		};

		function isPartOfFormGroup(disableSubmitForFormElement) {
			for (var key in $scope.DynaFormMain) {
				if (key.indexOf('$') == -1 && $scope.DynaFormMain[key].$name) {
					if ($scope.DynaFormMain[key].$name.indexOf(disableSubmitForFormElement) > -1) {
						return true;
					}
				}
			}
			return false;
		}

		function getFormGroupElements(disableSubmitForFormElement) {
			var formGroupElements = [];
			for (var key in $scope.DynaFormMain) {
				if (key.indexOf('$') == -1 && $scope.DynaFormMain[key].$name) {
					if ($scope.DynaFormMain[key].$name.indexOf(disableSubmitForFormElement) > -1) {
						formGroupElements.push($scope.DynaFormMain[key].$name);
					}
				}
			}
			return formGroupElements;
		}

		$scope.disableSubmit = function () {
			var submitIsDisable = false;
			var inputArray = window.disableSubmitForFormElements;
			for (var i = 0; i < inputArray.length; i++) {
				if (inputArray[i] && $scope.DynaFormMain[inputArray[i]]) {
					if (!$scope.DynaFormMain[inputArray[i]].$viewValue) {
						submitIsDisable = true;
					}
				} else if (inputArray[i] && isPartOfFormGroup(inputArray[i])) {
					var formGroupElements = getFormGroupElements(inputArray[i]);
					for (var j = 0; j < formGroupElements.length; j++) {
						var isItNotTitle = true;
						var titleCounter = 0;
						if (formGroupElements[j].slice(-6) === '_title') {
							for (var k = 0; k < formGroupElements.length; k++) {
								if (formGroupElements[k].slice(-9) === '_lastname' || formGroupElements[k].slice(-10) === '_firstname') {
									titleCounter++;
								}
							}
							if (titleCounter === 2) {
								isItNotTitle = false;
							}
						}
						if (!$scope.DynaFormMain[formGroupElements[j]].$viewValue) {
							if (isItNotTitle) {
								submitIsDisable = true;
							}
						}
					}
				}
			}
			return submitIsDisable || $scope.backgroundOperationInProgress || storgeFactory.formAlreadyCompleted(getFormId());
		};

		$scope.bindCaptchaId = function (captchaElementId) {
			var captchaId = angular
				.element('#' + captchaElementId + ' .captcha-image')
				.attr('src')
				.match(/(m|s)[0-9]*.jpg/)[0]
				.match(/(m|s)[0-9]*/)[0];
			$scope.data[$scope.currentStep][captchaElementId].id = captchaId;
		};

		$scope.setCaptchaResponse = function (captchaElementId, response) {
			$scope.captchaElementId = captchaElementId;
			$scope.data[$scope.currentStep][captchaElementId] = response;
			$scope.DynaFormMain[captchaElementId].$setValidity('captchaIsExpired', true);
		};

		$scope.initMultiselect = function (selectModelName, selectOptionsArrayName) {
			if (typeof window[selectOptionsArrayName] != 'undefined') {
				$scope[selectOptionsArrayName] = window[selectOptionsArrayName];
				$scope[selectModelName] = [];
			}
		};

		$scope.toggleMultiselectItem = function (model, item) {
			var itemIndex = model.indexOf(item);

			if (itemIndex == -1) {
				model.push(item);
			} else {
				model.splice(itemIndex, 1);
			}
		};

		$scope.cbExpiration = function (nameId) {
			$scope.DynaFormMain[nameId].$setValidity('captchaIsExpired', false);
		};

		// DATEPICKER
		$scope.datepickerOptions = {
			changeMonth: !0,
			changeYear: !0,
			showOn: 'button',
			buttonImage: '/static-ut/sw/g/myts-asp/datepicker.png',
			buttonImageOnly: true,
			buttonText: 'Válasszon dátumot',
			maxDate: '+1m'
		};

		$scope.refreshDS = function () {
			var designSelectList = document.querySelectorAll('.designSelect');
			setTimeout(function () {
				for (var i = 0; i < designSelectList.length; i++) {
					if (designSelectList[i].attributes['data-design-select']) {
						window.designSelectRefresh(designSelectList[i]);
					}
				}
			});
		};

		const fillMtEmail = (emailInputId, emailAddress) => {
			$scope.data[$scope.currentStep][emailInputId] = emailAddress;
		};
		const fillMtPhone = (phoneNumberInputId, phoneNumber) => {
			if ($scope.data[$scope.currentStep][phoneNumberInputId]) {
				const phoneNumberParts = phoneNumber.match(/36(\d{2})(\d*)/);
				$scope.data[$scope.currentStep][phoneNumberInputId][`${phoneNumberInputId}_select`] = parseInt(phoneNumberParts[1]);
				$scope.data[$scope.currentStep][phoneNumberInputId][`${phoneNumberInputId}_input`] = parseInt(phoneNumberParts[2], 10);
			}
		};
		$scope.selectSubscriber = (index, event) => {
			if (event) {
				event.stopPropagation();
				event.preventDefault();
			}
			$scope.selectedSubscriberIndex = index;
			const tfData = $scope.mtUserFormModel.userDetails;
			const selectedAsset = tfData.assets[$scope.selectedSubscriberIndex];
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.MT_ID] = selectedAsset.mtId;
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.NAME] = selectedAsset.name;
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.FLAGS] = selectedAsset.productCategories.join(',');
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.VAT_NUMBER] = selectedAsset.vatNumber;
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.CET_GROUP_ID] = selectedAsset.cetGroupId;
			if (selectedAsset.productCategories.includes(MAGENTA_ID)) {
				$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.PHONE] = tfData.phoneNumber;
			} else {
				$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.PHONE] = tfData.phoneNumber || selectedAsset.phoneNumber;
			}
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.PHONE] = tfData.phoneNumber || selectedAsset.phoneNumber;
			if (window.mtUserDataFormInputs.phoneNumber && window.mtUserDataFormInputs.phoneNumber.length) {
				$scope.taxNumber = selectedAsset.vatNumber;
				window.mtUserDataFormInputs.phoneNumber.forEach((phoneNumberInputId) => {
					const phoneNumber = $scope.mtUserFormModel.userDetails.assets[$scope.selectedSubscriberIndex].phoneNumber || $scope.mtUserFormModel.userDetails.phoneNumber;
					if (phoneNumber && phoneNumberInputId) {
						fillMtPhone(phoneNumberInputId, phoneNumber);
					}
				});
			}
		};

		const convertCategoryList = (categoryList, type) => {
			const newCategoryList = [];
			if (type == ORGANIZATION_TYPE_ID) {
				newCategoryList.push('Üzleti');
			}
			if (categoryList.includes(FIXED_ID)) {
				newCategoryList.push('Otthoni szolgáltatás');
			}
			if (categoryList.includes(UNLIMITED_DATA_ID)) {
				newCategoryList.push('Korlátlan havidíjas mobil');
			} else if (categoryList.includes(POSTPAID_ID)) {
				newCategoryList.push('Havidíjas mobil');
			}
			if (categoryList.includes(PREPAID_ID)) {
				newCategoryList.push('Domino');
			}
			return newCategoryList.join(', ');
		};

		$scope.isInit = function () {
			return $scope.loadingState == LOADING_STATES.INIT;
		};
		$scope.isLoading = function () {
			return $scope.loadingState == LOADING_STATES.LOADING;
		};
		$scope.isNotAuthorized = function () {
			return $scope.loadingState == LOADING_STATES.NOT_AUTHORIZED;
		};
		$scope.isSuccess = function () {
			return $scope.loadingState == LOADING_STATES.SUCCESS;
		};
		$scope.isTechnicalError = function () {
			return $scope.loadingState == LOADING_STATES.TECHNICAL_ERROR;
		};
		$scope.isFieldNotAvailable = function () {
			return $scope.loadingState == LOADING_STATES.FIELDS_NOT_AVAILABLE;
		};
		function fillMtUserInputs(tfData) {
			if (tfData.email && window.mtUserDataFormInputs.email) {
				var mailId = window.mtUserDataFormInputs.email;
				$scope.data[$scope.currentStep][mailId] = tfData.email;
			}
		}
		function getMtUserDataLegacy() {
			$scope.loadingState = LOADING_STATES.LOADING;
			$scope.mtUserFormModel.subscriberNameRestKey = `${window.mtUserDataFormInputs.mtUserSelect}_mt_name`;
			$scope.mtUserFormModel.subscriberMtIdRestKey = `${window.mtUserDataFormInputs.mtUserSelect}_mt_id`;
			$scope.exceptArrayForDeleteWhenSubmit.push($scope.mtUserFormModel.subscriberNameRestKey, $scope.mtUserFormModel.subscriberMtIdRestKey);

			dynaFormFactory.getMtUserDataFormInputsLegacy().then(
				(response) => {
					let responseData = response.data;
					$scope.mtUserFormModel.subscriberList = dynaFormFactory.getSubscriberList(responseData.legacyUsers);
					if ($scope.mtUserFormModel.subscriberList.length > 0) {
						$scope.exceptArrayForDeleteWhenSubmit.push(TF_DATA_POST_KEYS.TF_ID, TF_DATA_POST_KEYS.PHONE, TF_DATA_POST_KEYS.EMAIL);

						$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.TF_ID] = responseData.tfUser.tfData.tfId;
						$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.EMAIL] = responseData.tfUser.tfData.email || '';

						fillMtUserInputs(responseData.tfUser.tfData);
						$scope.mtUserFormModel.selectIsDisabled = false;
						$scope.refreshDS();
						$scope.loadingState = LOADING_STATES.SUCCESS;
					} else {
						$scope.loadingState = LOADING_STATES.TECHNICAL_ERROR;
					}
				},
				(err) => {
					if (err.status == 401) {
						$scope.loadingState = LOADING_STATES.NOT_AUTHORIZED;
					} else {
						$scope.loadingState = LOADING_STATES.TECHNICAL_ERROR;
					}
				}
			);
		}
		$scope.isMagenta = function (index) {
			return $scope.mtUserFormModel.userDetails.assets[index].productCategories.includes(MAGENTA_ID);
		};
		$scope.isOrganization = function (index) {
			return $scope.mtUserFormModel.userDetails.assets[index].type == ORGANIZATION_TYPE_ID;
		};
		$scope.setMtUserPostData = function (index) {
			if (!index) {
				return;
			}

			let selectedSubscriber = $scope.mtUserFormModel.subscriberList[index];
			$scope.data[$scope.currentStep][$scope.mtUserFormModel.subscriberNameRestKey] = selectedSubscriber.name;
			$scope.data[$scope.currentStep][$scope.mtUserFormModel.subscriberMtIdRestKey] = selectedSubscriber.mtId;

			var phoneNumberInputId = window.mtUserDataFormInputs.phoneNumber;
			if (phoneNumberInputId) {
				let phoneNumberData = dynaFormFactory.getPhoneNumberFromMtUserData(phoneNumberInputId, selectedSubscriber.phoneNumber);
				$scope.data[$scope.currentStep][phoneNumberInputId][`${phoneNumberInputId}_select`] = phoneNumberData.phoneArea;
				$scope.data[$scope.currentStep][phoneNumberInputId][`${phoneNumberInputId}_input`] = phoneNumberData.phoneNumber;
			}
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.PHONE] = selectedSubscriber.phoneNumber;
		};

		function getMtUserData() {
			$scope.loadingState = LOADING_STATES.LOADING;
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.CAMPAIGN_NAME] = window.mtUserDataCampaignName;
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.INCLUDED_CATEGORIES] = window.mtUserDataFilter && window.mtUserDataFilter.productCategories.join(',');
			$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.EXCLUDED_CATEGORIES] = window.mtUserDataFilter && window.mtUserDataFilter.excludedProductCategories.join(',');

			$scope.exceptArrayForDeleteWhenSubmit = Object.values(TF_DATA_POST_KEYS);

			dynaFormFactory.getMtUserDataFormInputs(window.mtUserDataFilter || {}).then(
				(response) => {
					const clonedResponse = angular.copy(response.data);
					clonedResponse.assets =
						clonedResponse.assets &&
						clonedResponse.assets.map((item) => {
							item.productCategoryList = $sce.trustAsHtml(convertCategoryList(item.productCategories, item.type));
							return item;
						});
					$scope.mtUserFormModel.userDetails = clonedResponse;
					const hasServices = $scope.mtUserFormModel.userDetails && $scope.mtUserFormModel.userDetails.assets && $scope.mtUserFormModel.userDetails.assets.length;
					if (hasServices) {
						const isEmailAvailable = response.data && response.data.emailAddress;
						const isEmailFieldAvailable = window.mtUserDataFormInputs && window.mtUserDataFormInputs.email;
						$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.TF_NAME] = clonedResponse.fullName;
						$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.TF_ID] = clonedResponse.tfId;
						$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.EMAIL] = clonedResponse.emailAddress;
						$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.PHONE] = clonedResponse.phoneNumber;
						if ($scope.mtUserFormModel.userDetails.assets.length == 1) {
							$scope.selectSubscriber(0);
						}
						if (isEmailAvailable && isEmailFieldAvailable) {
							const emailAddress = $scope.mtUserFormModel.userDetails.emailAddress;
							window.mtUserDataFormInputs.email.forEach((emailInputId) => {
								if (emailInputId && emailAddress) {
									fillMtEmail(emailInputId, emailAddress);
								}
							});
						}
						$scope.loadingState = LOADING_STATES.SUCCESS;
					} else {
						$scope.loadingState = LOADING_STATES.FIELDS_NOT_AVAILABLE;
					}
				},
				(err) => {
					if (err.status == 401) {
						$scope.loadingState = LOADING_STATES.NOT_AUTHORIZED;
					} else {
						$scope.loadingState = LOADING_STATES.TECHNICAL_ERROR;
					}
				}
			);
		}
		const getMtContactData = () => {
			$scope.loadingState = LOADING_STATES.LOADING;
			dynaFormFactory.getMtContactDataFormInputs().then(
				(response) => {
					$scope.mtUserFormModel.contactDetails = response.data;
					const isEmailAvailable = response.data && response.data.emailAddress;
					const isPhoneAvailable = response.data && response.data.phoneNumber;

					const isEmailFieldAvailable = window.mtContactDataFormInputs && window.mtContactDataFormInputs.email;
					const isPhoneFieldAvailable = window.mtContactDataFormInputs && window.mtContactDataFormInputs.phoneNumber;
					$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.TF_NAME] = response.data.fullName;
					$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.TF_ID] = response.data.tfId;
					$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.EMAIL] = response.data.emailAddress;
					$scope.data[$scope.currentStep][TF_DATA_POST_KEYS.PHONE] = response.data.phoneNumber;

					if (isEmailAvailable && isEmailFieldAvailable) {
						const emailAddress = $scope.mtUserFormModel.contactDetails.emailAddress;
						window.mtContactDataFormInputs.email.forEach((emailInputId) => {
							if (emailInputId && emailAddress) {
								fillMtEmail(emailInputId, emailAddress);
							}
						});
					}
					if (isPhoneAvailable && isPhoneFieldAvailable) {
						const phoneNumber = $scope.mtUserFormModel.contactDetails.phoneNumber;
						window.mtContactDataFormInputs.phoneNumber.forEach((phoneNumberInputId) => {
							if (phoneNumber && phoneNumberInputId) {
								fillMtPhone(phoneNumberInputId, phoneNumber);
							}
						});
					}
					if (!isEmailAvailable) {
						$scope.isMissingDataEmail = true;
					}
					if (!isPhoneAvailable) {
						$scope.isMissingDataPhone = true;
					}
					$scope.loadingState = LOADING_STATES.SUCCESS;
				},
				(err) => {
					if (err.status == 401) {
						$scope.loadingState = LOADING_STATES.NOT_AUTHORIZED;
					} else {
						$scope.loadingState = LOADING_STATES.TECHNICAL_ERROR;
					}
				}
			);
		};
		/**
		 * Alapesetben undefined állapotban a checkbox model ezért default értéket kell beállítni, hogy postnál string menyjen BE felé
		 */
		const setDefaultValueToDmCheckbox = () => {
			$scope.data[$scope.currentStep].dm1Accepted = $scope.data[$scope.currentStep].dm1Accepted || 'Nem';
			$scope.data[$scope.currentStep].dm2Accepted = $scope.data[$scope.currentStep].dm2Accepted || 'Nem';
			$scope.data[$scope.currentStep].dm3Accepted = $scope.data[$scope.currentStep].dm3Accepted || 'Nem';
			$scope.data[$scope.currentStep].dm4Accepted = $scope.data[$scope.currentStep].dm4Accepted || 'Nem';
			$scope.data[$scope.currentStep].informationTextReaded = 'Nem';
		};

		$scope.informationTextReadCheckboxChanged = () => {
			$scope.optinModel.selectAllDmCheckboxIsDisabled = false;
			$scope.setAllDmAcceptedCheckbox();
		};

		$scope.allDmAcceptedChanged = () => {
			$scope.data[$scope.currentStep].dm1Accepted = $scope.optinModel.allDmAccepted ? 'Igen' : 'Nem';
			$scope.data[$scope.currentStep].dm2Accepted = $scope.optinModel.allDmAccepted ? 'Igen' : 'Nem';
			$scope.data[$scope.currentStep].dm3Accepted = $scope.optinModel.allDmAccepted ? 'Igen' : 'Nem';
			$scope.data[$scope.currentStep].dm4Accepted = $scope.optinModel.allDmAccepted ? 'Igen' : 'Nem';
		};

		$scope.setAllDmAcceptedCheckbox = () => {
			const isOk = (dmAccepted) => {
				return dmAccepted === 'Igen';
			};

			let allDmCheckboxChecked = isOk($scope.data[$scope.currentStep].dm1Accepted) && isOk($scope.data[$scope.currentStep].dm2Accepted) && isOk($scope.data[$scope.currentStep].dm3Accepted) && isOk($scope.data[$scope.currentStep].dm4Accepted);

			if (allDmCheckboxChecked) {
				$scope.optinModel.selectAllDmCheckboxIsDisabled = false;
				$scope.data[$scope.currentStep].informationTextReaded = 'Igen';
			}

			$scope.optinModel.allDmAccepted = allDmCheckboxChecked;
		};

		$scope.toggleConditionalText = () => {
			$scope.optinModel.conditionalTextIsOpened = !$scope.optinModel.conditionalTextIsOpened;
		};

		$scope.toggleDmCheckboxes = () => {
			$scope.optinModel.dmCheckboxesIsOpened = !$scope.optinModel.dmCheckboxesIsOpened;
		};

		$scope.contactSubscriberName = (inputGroupId) => {
			let lastName = $scope.data[$scope.currentStep][inputGroupId][`${inputGroupId}_lastname`];
			let firstName = $scope.data[$scope.currentStep][inputGroupId][`${inputGroupId}_firstname`];

			if (firstName && lastName) {
				let title = $scope.data[$scope.currentStep][inputGroupId][`${inputGroupId}_title`] ? `${$scope.data[$scope.currentStep][inputGroupId][`${inputGroupId}_title`]} ` : '';
				$scope.optinModel.contactedSubscriberName = `${title}${lastName} ${firstName}`;
			}
		};

		$scope.hasMobile = (index) => {
			return $scope.mtUserFormModel.userDetails.assets[index].productCategories.includes(MAGENTA_ID) || !$scope.mtUserFormModel.userDetails.assets[index].productCategories.includes(FIXED_ID);
		};

		/**
		 * Kezdeti értéket ad a szükséges inputoknak, hogy user interakció nélkül is legyen beküldve érték a reportba
		 */
		const initDefaultFormData = () => {
			if (window.dynaFormActiveFunctions && window.dynaFormActiveFunctions.dmCheckbox) {
				setDefaultValueToDmCheckbox();
			}
		};
		const setLoginUrl = () => {
			// FIXME client_id=portal
			const searchParams = new URLSearchParams('scope=openid&response_type=code&client_id=onecare&display=page');
			searchParams.set('state', uuidv4());
			searchParams.set('nonce', uuidv4());
			searchParams.set('redirect_uri', window.location.href);
			$scope.loginUrl = `${window.location.protocol}//${window.location.host}/belepes/api/oidc/authorize?${searchParams.toString()}`;
		};
		function init() {
			setLoginUrl();
			checkAvasAddressSelectorIsExist();
			$scope.emptyCurrentStep();
			initDefaultFormData();
			$scope.refreshDS();
			if (!window.callMtUserDataRest && !window.callMtContactDataRest && !window.callMtUserDataLegacyRest) {
				$scope.loadingState = LOADING_STATES.SUCCESS;
			}
			if (window.callMtUserDataRest) {
				getMtUserData();
			}
			if (window.callMtUserDataLegacyRest) {
				getMtUserDataLegacy();
			}
			if (window.callMtContactDataRest) {
				getMtContactData();
			}
			storgeFactory.checkExpiredCompletedForms(getFormId());
			$timeout(function () {
				$scope.setDefaultInputValues();
			});
		}

		init();
	}
];
